import { paths } from 'src/routes/paths';

import { CatchMomentsIconSX } from 'src/components/icon';

// ----------------------------------------------------------------------


const ICONS = {
  dashboard: CatchMomentsIconSX('dashboard', { width: '20px !important', height: '20px !important' }),
  search: CatchMomentsIconSX('search', { width: '20px !important', height: '20px !important' }),
  keywordMonitoring: CatchMomentsIconSX('brand', { width: '20px !important', height: '20px !important' }),
  influencer: CatchMomentsIconSX('influencer', { width: '20px !important', height: '20px !important' }),
  brand: CatchMomentsIconSX('social', { width: '20px !important', height: '20px !important' }),
  blog: CatchMomentsIconSX('blog', { width: '20px !important', height: '20px !important' }),
  campaign: CatchMomentsIconSX('check', { width: '20px !important', height: '20px !important' }),
  admin: CatchMomentsIconSX('crown', { width: '20px !important', height: '20px !important' }),
  home: CatchMomentsIconSX('home', { width: '20px !important', height: '20px !important' }),
  pricing: CatchMomentsIconSX('pricing', { width: '20px !important', height: '20px !important' }),
  service: CatchMomentsIconSX('service', { width: '20px !important', height: '20px !important' }),
  sales: CatchMomentsIconSX('sales', { width: '20px !important', height: '20px !important' }),
  help: CatchMomentsIconSX('help', { width: '20px !important', height: '20px !important' }),
  trial: CatchMomentsIconSX('trial', { width: '20px !important', height: '20px !important' }),
}

export const navData = [
  {
    title: '홈',
    path: paths.home.root,
    icon: ICONS.home,
  },
  {
    title: '소개',
    path: paths.home.intro,
    icon: ICONS.trial,
  },
  // {
  //   title: 'Search',
  //   path: paths.home.search,
  //   // icon: <Iconify width={22} icon="solar:home-angle-linear" />,
  // },
  // {
  //   title: 'Influencer',
  //   path: paths.home.influencer,
  //   // icon: <Iconify width={22} icon="solar:home-angle-linear" />,
  // },
  // {
  //   title: '알아보기',
  //   path: paths.service.root,
  //   icon: ICONS.trial,
  //   useDemoLogin: true,
  // },
  {
    title: '기능',
    path: paths.home.features,
    icon: ICONS.service,
  },
  {
    title: 'MCP',
    path: paths.home.mcp,
    icon: ICONS.sales,
  },
  {
    title: '요금',
    path: paths.subscription.plan,
    icon: ICONS.pricing,
  },
  {
    title: '가이드',
    path: paths.guide.root,
    icon: ICONS.help,
  },
  {
    title: '블로그',
    path: paths.home.blog,
    icon: ICONS.blog,
  },
  // {
  //   title: '워크스페이스',
  //   path: paths.service.root,
  //   icon: ICONS.service,
  // children: [
  //   {
  //     subheader: 'Live',
  //     items: [
  //       {
  //         title: '대시보드',
  //         path: paths.service.dashboard,
  //         icon: ICONS.dashboard,
  //       },
  //       {
  //         title: '트렌드 서치',
  //         path: paths.service.search,
  //         icon: ICONS.search,
  //       },
  //       {
  //         title: '키워드 모니터링',
  //         path: paths.service.keywordMonitoring,
  //         icon: ICONS.keywordMonitoring,
  //       },
  //       {
  //         title: '인플루언서 발굴',
  //         path: paths.service.influencer,
  //         icon: ICONS.influencer,
  //       },
  //       {
  //         title: '우리 브랜드 관리',
  //         path: paths.service.brand,
  //         icon: ICONS.brand,
  //       },
  //     ]
  //   },
  // ],
  // },

];
